/**
 * Formats a number to a string with 1 decimal place
 * @param value - The number to format
 * @returns The formatted number as a string
 */
export const formatNumber = value => {
  return value.toLocaleString(undefined, {
    maximumFractionDigits: 1
  });
};

/**
 * Converts a number to a compact number
 * @param value - The number to convert
 * @returns The number as a string with 'K' suffix if it's greater than 999 or 'M' suffix if it's greater than 999999
 */
export const formatToCmpctNumber = value => {
  const usformatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short'
  });
  return usformatter.format(value);
};

/**
 * Calculates summary statistics from a list of courses and combines them
 * with academy data to create an InDemandCareer object.
 *
 * @param academy - The base academy data.
 * @param courses - The list of courses associated with the academy, used to calculate summary stats.
 * @returns A new InDemandCareer object containing the original academy data,
 *          calculated statistics (average rating, total ratings, total hours, total exercises),
 *          and placeholder career images.
 */
export const buildInDemandCareer = (academy, courses = []) => {
  const summary = courses.reduce((acc, course) => {
    var _course$num_reviews, _course$rating, _course$content_lengt, _course$num_quizzes, _course$num_subscribe;
    const courseReviews = (_course$num_reviews = course === null || course === void 0 ? void 0 : course.num_reviews) !== null && _course$num_reviews !== void 0 ? _course$num_reviews : 0;
    const courseRating = (_course$rating = course === null || course === void 0 ? void 0 : course.rating) !== null && _course$rating !== void 0 ? _course$rating : 0;
    const courseContentLengthInSeconds = (_course$content_lengt = course === null || course === void 0 ? void 0 : course.content_length_video) !== null && _course$content_lengt !== void 0 ? _course$content_lengt : 0;
    const courseExercises = (_course$num_quizzes = course === null || course === void 0 ? void 0 : course.num_quizzes) !== null && _course$num_quizzes !== void 0 ? _course$num_quizzes : 0;
    const courseSubscribers = (_course$num_subscribe = course === null || course === void 0 ? void 0 : course.num_subscribers) !== null && _course$num_subscribe !== void 0 ? _course$num_subscribe : 0;
    const weightedRatingContribution = courseRating * courseReviews;
    if (course !== null && course !== void 0 && course.has_certificate) {
      acc.hasCertificate = true;
    }
    acc.totalContentHours += courseContentLengthInSeconds / 3600;
    acc.totalExercises += courseExercises;
    acc.totalReviews += courseReviews;
    acc.totalSubscribers += courseSubscribers;
    acc.weightedAvgRating += weightedRatingContribution;
    return acc;
  }, {
    hasCertificate: false,
    totalContentHours: 0,
    totalExercises: 0,
    totalReviews: 0,
    totalSubscribers: 0,
    weightedAvgRating: 0
  });
  const avgRating = summary.totalReviews > 0 ? summary.weightedAvgRating / summary.totalReviews : 0;
  return {
    ...academy,
    avgRating: avgRating,
    hasCertificate: summary.hasCertificate,
    totalContentHours: summary.totalContentHours,
    totalExercises: summary.totalExercises,
    totalReviews: summary.totalReviews,
    totalSubscribers: summary.totalSubscribers
  };
};
//# sourceMappingURL=utils.js.map